import script from "./AddPaymentMethodDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AddPaymentMethodDialog.vue?vue&type=script&setup=true&lang=js"

import "./AddPaymentMethodDialog.vue?vue&type=style&index=0&id=2fd47e96&lang=css"

const __exports__ = script;

export default __exports__